import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 1.5a.5.5 0 0 1 .497.442L3.5 2v.5a1 1 0 0 1 .997.925L4.5 3.5V5a1 1 0 0 1-.925.997L3.5 6v4a.5.5 0 0 1-.997.059L2.5 10V6a1 1 0 0 1-.997-.925L1.5 5V3.5a1 1 0 0 1 .925-.997L2.5 2.5V2a.5.5 0 0 1 .5-.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 1.5a.5.5 0 0 1 .497.442L6.5 2v4.5a1 1 0 0 1 .997.925L7.5 7.5V9a1 1 0 0 1-.925.998L6.5 10a.5.5 0 0 1-.997.059L5.5 10l-.075-.002a1 1 0 0 1-.922-.92L4.5 9V7.5a1 1 0 0 1 .925-.997L5.5 6.5V2a.5.5 0 0 1 .5-.5",
      style: {"fill-opacity":".4"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 1.5a.5.5 0 0 1 .496.442L9.5 2a1 1 0 0 1 .998.925L10.5 3v2a1 1 0 0 1-.925.997L9.5 6v4a.5.5 0 0 1-.996.059L8.5 10V6a1 1 0 0 1-.997-.925L7.5 5V3a1 1 0 0 1 .925-.997L8.5 2a.5.5 0 0 1 .5-.5"
    }, null, -1)
  ])))
}
export default { render: render }